import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DCButtonComponent } from './button.component';



@NgModule({
  declarations: [
    DCButtonComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DCButtonComponent
  ]
})
export class DCButtonModule { }
